import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ReplayCircleFilledRoundedIcon from '@mui/icons-material/ReplayCircleFilledRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import axiosInstance from "../../api/axiosInstance";
import moment from "moment/moment";
import "./sign.scss";

const Sign = () => {
    const [doc, setDoc] = useState(null);
    const lastDocId = useRef(null);
    const sigCanvas = useRef(null);

    const clearSignature = () => {
        sigCanvas.current.clear();
    };

    useEffect(() => {
        const fetchDocument = async () => {
            try {
                const res = await axiosInstance.get("ergo/sign/1");
                const newDoc = res.data?.[0];

                if (!newDoc) return;

                // Erstes Laden
                if (lastDocId.current === null) {
                    lastDocId.current = newDoc.DOCID;
                    setDoc(newDoc);
                    return;
                }

                // Neues Dokument erkannt
                if (newDoc.DOCID !== lastDocId.current) {
                    lastDocId.current = newDoc.DOCID;
                    setDoc(newDoc);

                    // Modal öffnen
                    console.log("Neues Dokument erkannt");
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchDocument();

        const interval = setInterval(fetchDocument, 5000); // alle 5 Sekunden prüfen

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="sign">
            <img src="/assets/logo.svg" alt="Logo" />

            {doc && (
                <div className="modal">
                    <div className="document">
                        <div className="top">
                            <DescriptionOutlinedIcon />
                            <h3>Lieferschein</h3>
                        </div>
                        <div className="header">
                            <div className="delivery">
                                <div className="group">
                                    <p>Nr. <span>{doc.WEIGHTSERIALNR}/{doc.WEIGHTID}</span></p>
                                    <p>Vom <span>{moment(doc.DOCDATE).format("L")}</span></p>
                                </div>
                                <div className="group">
                                    <p>MPP code: {doc.CUSTOMSTR3}</p>
                                </div>
                                <div className="group">
                                    <p>Transportbeginn: {moment(doc.UPDATED.replace("Z", "")).format("L LT")} Uhr</p>
                                    <p>Transportmittel: {doc.LORRYREGIST}</p>
                                </div>
                            </div>
                            <div className="customerData">
                                <div className="group">
                                    <h4>Kundendaten</h4>
                                    <p>
                                        {doc.COMPANYID}
                                    </p>
                                </div>
                                <div className="group">
                                    <h4>Bestimmungsort</h4>
                                    <p>
                                        {doc.DESTNAME1} {doc.DESTNAME2}
                                    </p>
                                    <p>
                                        {doc.ZIP}, {doc.PLACE}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: "120px" }}>Artikel Kodex</th>
                                    <th>Beschreibung</th>
                                    <th style={{ width: "120px" }}>VE</th>
                                    <th style={{ width: "120px" }}>Stück ME</th>
                                    <th style={{ width: "120px" }}>Menge</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>101</td>
                                    <td>Schotter 4-8 (to)</td>
                                    <td></td>
                                    <td>to</td>
                                    <td>17,34</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="line" />
                        <div className="signBox">
                            <div className="top">
                                <DescriptionOutlinedIcon />
                                <h4>Empfang bestägigen</h4>
                            </div>
                            <div className="box">
                                <SignatureCanvas
                                    ref={sigCanvas}
                                    penColor="black"
                                    canvasProps={{ className: "sigCanvas", width: 450, height: 200 }}
                                />
                                <div className="signLine" />
                            </div>
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button className="light" onClick={() => setDoc(null)}>Abbrechen</button>
                        </div>
                        <div className="right">
                            <button className="light" onClick={clearSignature}>
                                <ReplayCircleFilledRoundedIcon />
                                Zurücksetzen
                            </button>
                            <button>
                                <CheckRoundedIcon />
                                Bestätigen
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Sign;